import type { CustomerFeedback } from "./CustomerFeedback";
import type { ProfilePhoto } from "./ProfilePhoto";

export class CustomerFeedbackAggregableData {
    public originLocationName: string;

    public destinationLocationName: string;

    public departureAt: Date;

    public locationNames: Array<string>;

    public feedback: CustomerFeedback;

    public driverName: string;

    public profilePhoto: ProfilePhoto;
}
